import {
  connectBaseApi,
  createRpcQuery,
  createRpcMutation,
  customGroupClient,
  groupMembershipClient,
  resourceAccessGrantClient,
} from "@racoon/api";

const customGroupsApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listOrgGroups: createRpcQuery(build, customGroupClient, "listOrgGroups", {
      providesTags: ["CustomGroups"],
    }),
    createCustomGroupWithGrants: createRpcMutation(
      build,
      customGroupClient,
      "createCustomGroupWithGrants",
      {
        invalidatesTags: ["CustomGroups"],
      },
    ),
    listGroupMemberships: createRpcQuery(build, groupMembershipClient, "listGroupMemberships", {
      providesTags: ["GroupMemberships"],
    }),
    listGroupGrants: createRpcQuery(build, resourceAccessGrantClient, "listGroupGrants", {
      providesTags: ["GroupGrants"],
    }),
    updateCustomGroup: createRpcMutation(build, customGroupClient, "updateCustomGroup", {
      invalidatesTags: ["CustomGroups"],
    }),
    // Soft delete: takes the group's members and grants with it, restore brings them back.
    deleteCustomGroup: createRpcMutation(build, customGroupClient, "deleteCustomGroup", {
      invalidatesTags: ["CustomGroups", "GroupMemberships", "GroupGrants"],
    }),
    restoreCustomGroup: createRpcMutation(build, customGroupClient, "restoreCustomGroup", {
      invalidatesTags: ["CustomGroups", "GroupMemberships", "GroupGrants"],
    }),
    grantRoleAccessToScope: createRpcMutation(
      build,
      resourceAccessGrantClient,
      "grantRoleAccessToScope",
      {
        invalidatesTags: ["GroupGrants"],
      },
    ),
    updateResourceAccessGrant: createRpcMutation(
      build,
      resourceAccessGrantClient,
      "updateResourceAccessGrant",
      {
        invalidatesTags: ["GroupGrants"],
      },
    ),
    revokeGrant: createRpcMutation(build, resourceAccessGrantClient, "revokeGrant", {
      invalidatesTags: ["GroupGrants"],
    }),
    bulkUpdateGrantsOrganization: createRpcMutation(
      build,
      resourceAccessGrantClient,
      "bulkUpdateGrantsOrganization",
      {
        invalidatesTags: ["GroupGrants"],
      },
    ),
    addUserToGroup: createRpcMutation(build, groupMembershipClient, "addUserToGroup", {
      invalidatesTags: ["GroupMemberships"],
    }),
    removeUserFromGroup: createRpcMutation(build, groupMembershipClient, "removeUserFromGroup", {
      invalidatesTags: ["GroupMemberships"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListOrgGroupsQuery,
  useCreateCustomGroupWithGrantsMutation,
  useListGroupMembershipsQuery,
  useListGroupGrantsQuery,
  useLazyListGroupGrantsQuery,
  useUpdateCustomGroupMutation,
  useDeleteCustomGroupMutation,
  useRestoreCustomGroupMutation,
  useGrantRoleAccessToScopeMutation,
  useUpdateResourceAccessGrantMutation,
  useRevokeGrantMutation,
  useBulkUpdateGrantsOrganizationMutation,
  useAddUserToGroupMutation,
  useRemoveUserFromGroupMutation,
} = customGroupsApi;
